import "./App.css";
import { BrowserRouter as Router } from "react-router-dom";
import { ThemeProvider } from "flowbite-react";
import { lightTheme } from "./theme/lightTheme";
import AppRouter from "./components/AppRouter";
import { QueryClientContextProvider } from "./context/QueryClientContext";
import { AuthenticationProvider, ToastProvider, BusyProvider } from "@repo/core";
import { WebSocketProvider } from "./context/WebSocketContext";
import WebSocketMessageHandler from "./components/WebSocketMessageHandler";
import WebSocketManager from "./components/WebSocketManager";
import PreferredLanguageSync from "./components/PreferredLanguageSync";

function App() {
  return (
    // Router wraps AuthenticationProvider so login/logout/requireAuth can
    // navigate to local routes (e.g. /login) instead of doing a full-page
    // redirect to an external host.
    <Router>
      <QueryClientContextProvider>
        <AuthenticationProvider>
          <WebSocketProvider autoConnect={true}>
            <BusyProvider spinnerSize="xl" message="Loading...">
              <ToastProvider position="top-right" maxToasts={5}>
                <WebSocketManager />
                <WebSocketMessageHandler />
                <PreferredLanguageSync />
                <ThemeProvider theme={lightTheme}>
                  <AppRouter />
                </ThemeProvider>
              </ToastProvider>
            </BusyProvider>
          </WebSocketProvider>
        </AuthenticationProvider>
      </QueryClientContextProvider>
    </Router>
  );
}

export default App;
